// Importing this module is no longer required for the the "MoreColors" feature, but rather serves as a preload
import ColorPaletteMoreColorsTemplate from "./ColorPaletteMoreColorsTemplate.js";
import ColorPalette from "../ColorPalette.js";

ColorPalette.ColorPaletteMoreColorsTemplate = ColorPaletteMoreColorsTemplate;
